import React, { useEffect, useState, useRef } from "react";
import { DeletePopupModal, PopupModal, FormParser } from "../Components";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
import { deleteAccount } from "../Service/moderationApi";
import { MdOutlineFileCopy, MdOutlineVerified, MdVerified, MdDeleteOutline } from "react-icons/md"
import DataTable from 'react-data-table-component';
import "./master_categories.css";
import { Modal } from 'react-bootstrap';
import Masters from "../Components/masters.json"
import { MdFilterList, MdFilterListOff } from "react-icons/md";
import { AddUser } from "./AddUser"
import { hasPermission, canRevealMobileNumber } from "../Utils/permissionUtils";
import { isDialableMobileNumber, isProbablyMaskedMobileNumber } from "../Utils/mobileNumber";
import { useURLParams } from "../Components/UrlUtils/useURLParams";
import { useSearch } from "../Utils/SearchContext";
import useDebouncedValue from "../Utils/Debounce";
import { FaTimes } from "react-icons/fa";
const Users = () => {
    const { setParam, getParam, getMultiSelectParam, handleMultiSelect } = useURLParams();
    const [deletePopupType, setDeletepopupType] = useState("")
    const [loading, setLoading] = useState(false)
    const [loginShow, setloginShow] = useState(false);
    const handleLoginClose = () => setloginShow(false);
    const handleLoginShow = () => setloginShow(true);
    const [filterShow, setFilterShow] = useState(false)
    let navigate = useNavigate();
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("");
    const [ordering, setOrdering] = useState("");
    const priorityTimeout = useRef({});
    const [showRevealMobileModal, setShowRevealMobileModal] = useState(false);
    const [revealRow, setRevealRow] = useState(null);
    const [revealReason, setRevealReason] = useState("");
    const [revealError, setRevealError] = useState("");
    const [revealingMobile, setRevealingMobile] = useState(false);
    const [nextUrl, setNextUrl] = useState(null);
    const { query, setQuery } = useSearch();
    const [searchParams, setSearchParams] = useSearchParams()
    const [initialformData, setinitialFormData] = useState({});
    const debouncedSearchTerm = useDebouncedValue(query, 500);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleteReason, setDeleteReason] = useState("");
    const [deleteError, setDeleteError] = useState("");
    const [deletingAccount, setDeletingAccount] = useState(false);
    const [formData, setformData] = useState({
        department: getParam('department') || "",
        project_type: getParam('project_type') || "",
        role: getMultiSelectParam('role'),
        categories: getParam('categories') || "",
        skills: getParam('skills') || "",
        present_state: getParam('present_state') || "",
        present_city: getParam('present_city') || "",
        languages: getMultiSelectParam('languages'),
        gender: getParam('gender') || "",
        from_age: getParam('from_age') || "",
        to_age: getParam('to_age') || "",
        from_height: getParam('from_height') || "",
        to_height: getParam('to_height') || "",
        no_picture: getParam('no_picture') || "",
        is_pro: getParam('is_pro') || "",
        minor_status: getParam('minor_status') || "",
        ordering: getParam('ordering') || ""
    })
    function handleLoginEvent() {
        handleLoginClose();
    }
    function calculateAge(dob) {
        const dobDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - dobDate.getFullYear();
        const monthDiff = today.getMonth() - dobDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
            age--;
        }
        return age;
    };

    const [parmsData, setparmsData] = useState("")
    const [Data, SetData] = useState([])
    const generateQueryString = (data) => {
        const queryStringParts = Object.entries(data)
            .filter(([_, value]) => value && (Array.isArray(value) ? value.length > 0 : true)) // Filter out empty values
            .map(([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(Array.isArray(value) ? value.join(',') : value)}`
            );
        return queryStringParts.join('&');
    };
    const generateArrayQueryString = (key, array) => {
        return array && array.length > 0
            ? array.map(item => `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`).join('&')
            : '';
    };
    const constructApiParams = (page) => {
        const existingParams = window.location.search;
        const additionalParams = `page_size=${RowPerPage}&page=${page}`;
        return existingParams ? `${existingParams}&${additionalParams}` : `?${additionalParams}`;
    };
    const HandleSort = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, search_query: query, [name]: value };
        const dataStore = { ...formData, [name]: value }
        setformData(dataStore);
        setSearchParams(generateQueryString(updatedData));
        setCurrentPage(1)
    };
    const formSubmit = (Data) => {
        setFilterShow(false);
        const updatedData = { ...Data, search_query: query };
        setformData(Data);
        setSearchParams(generateQueryString(updatedData));
        setCurrentPage(1)
    };
    const handleInputChangeDebounced = (event) => {
        const newQuery = event.target.value;
        setQuery(newQuery);
        const updatedData = { ...formData, search_query: newQuery };
        setSearchParams(generateQueryString(updatedData));
    };
    const GetData = async () => {
        setLoading(true);
        const roleQueryString = generateArrayQueryString('role', formData.role);
        const languagesQueryString = generateArrayQueryString('languages', formData.languages);
        const apiParams = constructApiParams(currentPage);
        let url = `/accounts/user-profiles/${apiParams}${roleQueryString ? `&${roleQueryString}` : ''}${languagesQueryString ? `&${languagesQueryString}` : ''}`
        try {
            const response = await axiosConfig.get(url);
            setTotalRows(response.data.count);
            setNextUrl(response.data.next);
            SetData(response.data.results);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    const handleRemove = (key, itemToRemove = null) => {
        setformData((prevFormData) => {
            const newFormData = { ...prevFormData };
            if (Array.isArray(newFormData[key])) {
                newFormData[key] = newFormData[key].filter((item) => item !== itemToRemove);
            } else if (key === "query") {
                setQuery("")
            } else {
                newFormData[key] = '';
            }
            formSubmit(newFormData)
            return newFormData;
        });
    };
    const copyToClipboard = async (copy_item, item) => {
        console.log(item)
        let baseUrl = `${window.location.protocol}//${window.location.host}`;
        if (copy_item === "profile") {
            try {
                await navigator.clipboard.writeText(`${item.full_name} - ${item.designation} - ${calculateAge(item.dob)} years - ${item.state_city.city}(${item.state_city.state})  https://api.indiacastingclub.com/share/profile/${item.hcc_id}/`);
                console.log('Text copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy text to clipboard:', err);
            }
        } else {
            try {
                await navigator.clipboard.writeText(`${item.full_name} - ${item.designation} - ${calculateAge(item.dob)} years - ${item.state_city.city}(${item.state_city.state})  https://api.indiacastingclub.com/share/profile/${item.hcc_id}/`);
                console.log('Text copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy text to clipboard:', err);
            }
        }
    };
    const loadFormDataFromURL = () => {
        setLoading(true);
        setinitialFormData(formData);
        setLoading(false);
    };
    useEffect(() => {
        GetData();
        loadFormDataFromURL();
    }, [formData, debouncedSearchTerm, RowPerPage, currentPage]);
    const handleSorting = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`/accounts/user-profiles/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const openRevealMobileModal = (row) => {
        setRevealError("");
        setRevealReason("");
        setRevealRow({ id: row.id, hcc_id: row.hcc_id, full_name: row.full_name });
        setShowRevealMobileModal(true);
    };

    const openDeleteModal = (row) => {
        setDeleteTarget({ id: row.id, hcc_id: row.hcc_id, full_name: row.full_name });
        setDeleteReason("");
        setDeleteError("");
        setShowDeleteModal(true);
    };

    const confirmDeleteAccount = async () => {
        const reason = (deleteReason || "").trim();
        if (!reason) {
            setDeleteError("Reason is required to delete an account.");
            return;
        }
        if (!deleteTarget?.id) return;
        setDeletingAccount(true);
        setDeleteError("");
        try {
            await deleteAccount(deleteTarget.id, reason);
            setShowDeleteModal(false);
            setDeleteTarget(null);
            setDeleteReason("");
            setDeletepopupType("success");
            GetData();
        } catch (error) {
            setDeleteError(
                error?.response?.data?.detail ||
                error?.response?.data?.reason?.[0] ||
                "Failed to delete account."
            );
        } finally {
            setDeletingAccount(false);
        }
    };

    const confirmRevealMobile = async () => {
        const reason = (revealReason || "").trim();
        if (!reason) {
            setRevealError("Reason is required to reveal the number.");
            return;
        }
        if (!revealRow?.hcc_id) return;
        setRevealingMobile(true);
        try {
            const res = await axiosConfig.get(`/accounts/user-profiles/`, {
                params: {
                    hcc_id: revealRow.hcc_id,
                    reveal_mobile_number: 1,
                    reveal_reason: reason,
                },
            });
            const updated = res.data.results?.[0];
            if (updated) {
                SetData((prev) =>
                    prev.map((r) => (r.id === updated.id ? { ...r, ...updated } : r))
                );
            }
            setShowRevealMobileModal(false);
            setRevealRow(null);
        } catch (e) {
            setRevealError(
                e?.response?.data?.detail ||
                e?.response?.data?.error ||
                "Failed to reveal mobile number."
            );
        } finally {
            setRevealingMobile(false);
        }
    };
    const tableCustomStyles = {
        table: {
            style: {
                width: "100%"
            }
        },
        rows: {
            style: {
                width: "100%"
            }
        },
        cells: {
            style: {
                justifyContent: "center"
            }
        },
        headCells: {
            style: {
                justifyContent: "center",
                color: "rgb(33,37,41)",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "28px"
            }
        }
    }
    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true,
            width: "65px"
        },
        {
            name: "Name",
            selector: "full_name",
            cell: row =>
                <div>
                    <b>{row.hcc_id}</b><br />
                    <p onClick={() => window.open(`/dashboard/users/${row.hcc_id}/edit`, '_blank')} style={{ marginBottom: 0 }}>
                        <b style={{ color: row.is_pro === true ? "#6A0DAD" : "" }}>
                            {row.full_name}
                        </b>
                        {row.is_celebrity && <MdVerified size={12} color="#019bf9" />}
                        {!row.is_celebrity && row.is_verified && <MdOutlineVerified size={12} color="#808080" />}
                    </p>
                    {isDialableMobileNumber(row.mobile_number) ? (
                        <a href={`tel:${row.mobile_number}`}>{row.mobile_number}</a>
                    ) : (
                        <span>{row.mobile_number || "--"}</span>
                    )}
                    {canRevealMobileNumber() && isProbablyMaskedMobileNumber(row.mobile_number) && (
                        <>
                            <br />
                            <button
                                type="button"
                                className="btn btn-sm btn-primary mt-1"
                                onClick={() => openRevealMobileModal(row)}
                            >
                                Show number
                            </button>
                        </>
                    )}
                </div>,
            sortable: true,
            width: "185px"
        },
        {
            name: "Contact Details",
            selector: "email",
            cell: row =>
                <div>
                    {/* <b>{row.hcc_id}</b><br /> */}
                    {/* {isDialableMobileNumber(row.mobile_number) ? (
                        <a href={`tel:${row.mobile_number}`}>{row.mobile_number}</a>
                    ) : (
                        <span>{row.mobile_number || "--"}</span>
                    )}
                    {canRevealMobileNumber() && isProbablyMaskedMobileNumber(row.mobile_number) && (
                        <>
                            <br />
                            <button
                                type="button"
                                className="btn btn-sm btn-primary mt-1"
                                onClick={() => openRevealMobileModal(row)}
                            >
                                Show number
                            </button>
                        </>
                    )}
                    <br /> */}
                    {row.user.email}<br />
                    {row.gender} ({calculateAge(row.dob)} yrs)<br />
                    {row.state_city && <>{row.state_city.city} ({row.state_city.state})</>}
                </div>,
            sortable: true
        },
        {
            name: "Profile",
            selector: "profile_pic",
            cell: row =>
                <img className="image" src={row.profile_pic} alt={row.profile_pic} />,
            sortable: false,

        },
        {
            name: "Posts",
            selector: "total_posts",
            cell: row => row.total_posts,
            sortable: true,
            width: "80px"
        },
        {
            name: "Roles",
            selector: "roles",
            cell: row =>
                <div>
                    <div>{row.designation}</div>
                    {row.roles?.length > 0 && (
                        <div>
                            (<b>{row.roles.map(role => role.role_name).filter(Boolean).join(", ")}</b>)
                        </div>
                    )}
                </div>,
            sortable: true,
            width: "120px"
        },
        {
            name: "Priority",
            selector: "priority",
            cell: row => {
                const handlePriorityChange = (e) => {
                    const value = e.target.value;

                    SetData(prev =>
                        prev.map(item =>
                            item.id === row.id ? { ...item, priority: value } : item
                        )
                    );

                    if (priorityTimeout.current[row.id]) {
                        clearTimeout(priorityTimeout.current[row.id]);
                    }

                    priorityTimeout.current[row.id] = setTimeout(async () => {
                        try {
                            await axiosConfig.patch(`/accounts/user-profiles/${row.id}/`, {
                                priority: value || 0
                            });
                        } catch (error) {
                            console.log(error);
                        }
                    }, 600);
                };

                return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <input
                            type="number"
                            value={row.priority}
                            onChange={handlePriorityChange}
                            style={{
                                width: "70px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "4px"
                            }}
                        />
                        <div style={{ fontSize: "11px", marginTop: "4px" }}>
                            {row.is_pro ? "PRO" : ""}
                        </div>
                    </div>
                );
            },
            sortable: true,
            width: "90px"
        },
        {
            name: "ACTIONS",
            width: "170px",
            selector: row => {
                const HandleEdit = async () => {
                    window.open(`/dashboard/users/${row.hcc_id}/edit`, "_blank");
                }
                return (
                    <>
                        <div className="user-Actions">
                            <div className="d-flex justify-content-between align-items-center gap-3 mb-2">
                                <MdOutlineFileCopy onClick={() => copyToClipboard("profile", row)} className="Copy-icon" />
                                <div onClick={HandleEdit} className="view-btn">Edit</div>
                            </div>
                            {hasPermission("messagesapp.view_message") && (
                                <div className="message-btn mb-2" onClick={() => navigate(`/messages/${row.hcc_id}`)}>Message</div>
                            )}
                            {hasPermission("accounts.view_profile") && !row.is_deleted && (
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm w-100"
                                    onClick={() => openDeleteModal(row)}
                                >
                                    <MdDeleteOutline size={16} className="me-1" />
                                    Delete
                                </button>
                            )}
                            {row.is_deleted ? (
                                <span className="badge bg-secondary mt-1">Deleted</span>
                            ) : row.is_suspended ? (
                                <span className="badge bg-warning text-dark mt-1">Suspended</span>
                            ) : null}
                        </div>
                    </>
                )
            }
        }
    ]
    return (
        <>
            <div className="child-sidenav">
                <div className="childnav-content user-screen">
                    <div style={{ position: "relative" }}>
                        <div className="container-position filter_button_down" style={{
                            position: "sticky",
                            top: "-25px",
                            background: "#ffff",
                        }}>
                            <div class="inlineContainer">
                                <div className="cat-button">
                                    <div className="btn" onClick={handleLoginShow} >+ Add New</div>
                                </div>
                                <div className="sort-content">
                                    <select className="Selectbar" id="sortby" name="ordering" onChange={HandleSort} value={formData.ordering}>
                                        <option value="">Sort By</option>
                                        <option value="id">Fisrt to Last</option>
                                        <option value="-id">Last to First</option>
                                        <option value="user__first_name">Name (A to Z)</option>
                                        <option value="-user__first_name">Name (Z to A)</option>
                                    </select>
                                </div>
                                <div class="inlineHeader">
                                    <div className="view-btn filter-btn" onClick={() => setFilterShow(true)}><img src={require("./images/filtersearch.png")} alt="" />Filters ({totalRows})</div>
                                </div>
                                <div className="inlinBpContainer">
                                    {Object.entries(formData).map(([key, value], index) =>
                                        Array.isArray(value) && value.length > 0 ? (
                                            value.map((item, itemIndex) => (
                                                <button key={`${index}-${itemIndex}`} className="btn btn-shortlist shortlist-icon">
                                                    <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 0 }}>
                                                        <b>{`${key}: ${item}`}</b>
                                                        <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                            <FaTimes size={18} onClick={() => handleRemove(key, item)} />
                                                        </span>
                                                    </p>
                                                </button>
                                            ))
                                        ) : !Array.isArray(value) && value ? (
                                            <button key={index} className="btn btn-shortlist shortlist-icon">
                                                <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 0 }}>
                                                    <b>{`${key}: ${value}`}</b>
                                                    <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                        <FaTimes size={18} onClick={() => handleRemove(key)} />
                                                    </span>
                                                </p>
                                            </button>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="right-table">
                            <div className="table-responsive marginTop">
                                <DataTable
                                    columns={columns}
                                    data={Data} pagination paginationTotalRows={totalRows}
                                    paginationPerPage={RowPerPage}
                                    paginationDefaultPage={currentPage}
                                    onChangePage={(page) => setCurrentPage(page)}
                                    paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                    paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                    onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                                    onSort={handleSorting}
                                    paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                                    progressComponent={<div className="loader-container">
                                        <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                                    </div>}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {popupType !== "" &&
                <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="/dashboard/masters/products" />
            }
            {deletePopupType !== "" &&
                <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
            }
            <Modal
                show={filterShow}
                onHide={() => setFilterShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
                className="mobile-filter-pop modal-responsive"
            >
                <Modal.Body className="">
                    <button variant="primary" className="btn btn-default close-btn" onClick={() => setFilterShow(false)}>
                        X
                    </button>
                    <FormParser modelObject={Masters.FilterForm} formData={initialformData} formSubmit={formSubmit} />
                </Modal.Body>
            </Modal>
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={loginShow} onHide={handleLoginClose} className="login-popup">
                <Modal.Header closeButton>
                    <Modal.Title>Add New User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddUser handleLoginEvent={handleLoginEvent} />
                </Modal.Body>
            </Modal>
            <Modal
                centered
                show={showRevealMobileModal}
                onHide={() => {
                    if (!revealingMobile) {
                        setShowRevealMobileModal(false);
                        setRevealRow(null);
                    }
                }}
            >
                <Modal.Header closeButton={!revealingMobile}>
                    <Modal.Title>Reveal mobile number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {revealRow?.full_name && (
                        <div className="mb-2 text-muted small">{revealRow.full_name} · HCC {revealRow.hcc_id}</div>
                    )}
                    <div className="mb-2">
                        Mobile is audited when revealed. Please enter a reason.
                    </div>
                    <textarea
                        className="form-control"
                        rows={3}
                        value={revealReason}
                        disabled={revealingMobile}
                        onChange={(e) => {
                            setRevealReason(e.target.value);
                            setRevealError("");
                        }}
                        placeholder="Required reason (e.g., 'Calling for audition schedule')"
                    />
                    {revealError && <div className="text-danger mt-2">{revealError}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        disabled={revealingMobile}
                        onClick={() => {
                            setShowRevealMobileModal(false);
                            setRevealRow(null);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={revealingMobile}
                        onClick={confirmRevealMobile}
                    >
                        Reveal
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                centered
                show={showDeleteModal}
                onHide={() => {
                    if (!deletingAccount) {
                        setShowDeleteModal(false);
                        setDeleteTarget(null);
                    }
                }}
            >
                <Modal.Header closeButton={!deletingAccount}>
                    <Modal.Title>Delete account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {deleteTarget && (
                        <div className="mb-2 text-muted small">
                            {deleteTarget.full_name} · HCC {deleteTarget.hcc_id}
                        </div>
                    )}
                    <p className="small text-danger mb-2">
                        This permanently soft-deletes the account. The user cannot log in and will be hidden from all public views.
                    </p>
                    <label className="form-label"><b>Reason</b> (required)</label>
                    <textarea
                        className="form-control"
                        rows={3}
                        value={deleteReason}
                        disabled={deletingAccount}
                        onChange={(e) => {
                            setDeleteReason(e.target.value);
                            setDeleteError("");
                        }}
                        placeholder="e.g. Confirmed fraud — account terminated"
                    />
                    {deleteError && <div className="text-danger mt-2">{deleteError}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        disabled={deletingAccount}
                        onClick={() => {
                            setShowDeleteModal(false);
                            setDeleteTarget(null);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        disabled={deletingAccount}
                        onClick={confirmDeleteAccount}
                    >
                        {deletingAccount ? "Deleting..." : "Delete account"}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export { Users }